import NewsList from "./NewsList.container";

export default NewsList;
